import { render, staticRenderFns } from "./PlayModeToggle.vue?vue&type=template&id=56c67709&scoped=true&"
import script from "./PlayModeToggle.vue?vue&type=script&lang=js&"
export * from "./PlayModeToggle.vue?vue&type=script&lang=js&"
import style0 from "./PlayModeToggle.vue?vue&type=style&index=0&id=56c67709&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56c67709",
  null
  
)

export default component.exports